const SmartOosIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="29.345"
      height="29.632"
      viewBox="0 0 29.345 29.632"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5536"
            data-name="Rectangle 5536"
            width="29.345"
            height="29.632"
            fill="#707070"
          />
        </clipPath>
      </defs>
      <g id="Group_9441" data-name="Group 9441" transform="translate(0 0)">
        <g
          id="Group_9440"
          data-name="Group 9440"
          transform="translate(0 0)"
          clipPath="url(#clip-path)"
        >
          <path
            id="Path_12171"
            data-name="Path 12171"
            d="M22.793,0H1.145A1.145,1.145,0,0,0,0,1.145V22.79a1.147,1.147,0,0,0,1.145,1.148H8.9a.7.7,0,0,0,.657-.9,9.768,9.768,0,0,1,.8-7.41,10.89,10.89,0,0,1,8.009-5.907,10.683,10.683,0,0,1,4.644.387.7.7,0,0,0,.93-.652V1.145A1.145,1.145,0,0,0,22.793,0M15.2,5.136H7.586a1.5,1.5,0,1,1,0-3.006H15.2a1.5,1.5,0,1,1,0,3.006"
            transform="translate(0 0.001)"
            fill="#707070"
          />
          <path
            id="Path_12172"
            data-name="Path 12172"
            d="M13.756,4.523a9.352,9.352,0,1,0,9.35,9.352,9.364,9.364,0,0,0-9.35-9.352m7.42,9.352a7.352,7.352,0,0,1-1.2,4.013l-11-9.64a7.345,7.345,0,0,1,4.779-1.793,7.429,7.429,0,0,1,7.42,7.42m-14.839,0A7.361,7.361,0,0,1,7.661,9.664l11.056,9.688a7.387,7.387,0,0,1-12.38-5.477"
            transform="translate(6.236 6.405)"
            fill="#707070"
          />
        </g>
      </g>
    </svg>
  )
}

export default SmartOosIcon
